import { render, staticRenderFns } from "./MyFlow.vue?vue&type=template&id=85489f96&scoped=true&"
import script from "./MyFlow.vue?vue&type=script&lang=js&"
export * from "./MyFlow.vue?vue&type=script&lang=js&"
import style0 from "./MyFlow.vue?vue&type=style&index=0&id=85489f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85489f96",
  null
  
)

export default component.exports